import * as React from "react";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";
import AppBar, { AppBarEmptyLeftIconPadding } from "nx-components/AppBar";
import Environment from "nexia_mobile/environment";
import DrawerRevealer from "nexia_mobile/components/TopBar/DrawerRevealer";
import BackButton from "nexia_mobile/components/TopBar/BackButton";
import ModeSelector from "nexia_mobile/components/TopBar/ModeSelector";
import ResourceNameEditor from "nexia_mobile/components/TopBar/ResourceNameEditor";
import ChoicesBannerContainer from "nexia_mobile/components/TopBar/ChoicesBannerContainer";

export class CommonAppBar extends React.Component {
  static propTypes = {
    iconLeft: PropTypes.node,
    iconRight: PropTypes.node,
    title: PropTypes.node.isRequired,
    isTitleEditable: PropTypes.bool,
    resourceHref: PropTypes.string,
    isLargeAppLayout: PropTypes.bool.isRequired,
    onEditorEnd: PropTypes.func,
  };

  static defaultProps = {
    iconRight: Environment.isCommercial() ? null : <ModeSelector />,
  };

  render() {
    const {
      iconLeft,
      iconRight,
      title,
      isTitleEditable,
      resourceHref,
      onEditorEnd,
      isLargeAppLayout,
    } = this.props;

    const titleElement = isTitleEditable ? (
      <ResourceNameEditor
        initialValue={title}
        resourceHref={resourceHref}
        onEditEnd={onEditorEnd}
      />
    ) : (
      title
    );

    const iconLeftForTopLevel = (isTopLevel) => {
      if (isTopLevel) {
        return isLargeAppLayout ? (
          <AppBarEmptyLeftIconPadding />
        ) : (
          <DrawerRevealer />
        );
      } else {
        return <BackButton />;
      }
    };

    return (
      <Route
        render={({ history }) => {
          const atTopOfHistory =
            history.index === 0 ||
            (history.index === 1 &&
              history.replacedLocation != null &&
              history.entries[0] === history.replacedLocation.location);

          return (
            <React.Fragment>
              <AppBar
                iconLeft={
                  iconLeft === undefined
                    ? iconLeftForTopLevel(atTopOfHistory)
                    : iconLeft
                }
                title={titleElement}
                iconRight={iconRight}
              />
              <ChoicesBannerContainer />
            </React.Fragment>
          );
        }}
      />
    );
  }
}

export default class CommonAppBarContainer extends React.Component {
  static propTypes = {
    iconLeft: PropTypes.node,
    iconRight: PropTypes.node,
    title: PropTypes.node.isRequired,
    isTitleEditable: PropTypes.bool,
    resourceHref: PropTypes.string,
    onEditorEnd: PropTypes.func,
  };

  static contextTypes = {
    isLargeAppLayout: PropTypes.bool,
  };

  render() {
    const {
      iconLeft,
      iconRight,
      title,
      isTitleEditable,
      resourceHref,
      onEditorEnd,
    } = this.props;

    const { isLargeAppLayout } = this.context;

    return (
      <CommonAppBar
        iconLeft={iconLeft}
        iconRight={iconRight}
        title={title}
        isTitleEditable={isTitleEditable}
        resourceHref={resourceHref}
        onEditorEnd={onEditorEnd}
        isLargeAppLayout={isLargeAppLayout}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TopBar/CommonAppBarContainer.jsx